import React from "react";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import HubIcon from "@mui/icons-material/Hub";
import InputIcon from "@mui/icons-material/Input";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";
import VideocamIcon from "@mui/icons-material/Videocam";
import { COLORS } from "./constants";
import { SECTION_IDS } from "./Sidebar";

// ─────────────────────────────────────────────────────────────────────────────
// MobileBottomNav
//
// On a phone the dashboard is one long scroll, and the section jump list was
// buried behind the hamburger drawer — two taps to reach anything, with the
// drawer covering the thing you just jumped to.
//
// These are SCROLL targets, not routes. The design's mobile artboard shows a
// tab bar, but this dashboard genuinely is a single page: making these switch
// views would mean unmounting panels, and BrowserEncodePanel cannot be
// unmounted without killing a live broadcast (see SourcePanel). Scrolling
// gives the same reachability and keeps every panel alive.
//
// NAV_HEIGHT is exported so the page can reserve matching bottom padding —
// the bar is fixed, so without it the last panel sits underneath.
// ─────────────────────────────────────────────────────────────────────────────

export const NAV_HEIGHT = 62;

const ITEMS = [
  { id: SECTION_IDS.preview,      label: "Live",    Icon: VideocamIcon },
  { id: SECTION_IDS.source,       label: "Source",  Icon: InputIcon },
  { id: SECTION_IDS.destinations, label: "Outputs", Icon: HubIcon },
  { id: SECTION_IDS.diagnostics,  label: "Signal",  Icon: TroubleshootIcon }
];

export function MobileBottomNav() {
  const [value, setValue] = React.useState(0);

  const jump = (index) => {
    setValue(index);
    const el = typeof document !== "undefined" && document.getElementById(ITEMS[index].id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <Paper
      square
      elevation={0}
      sx={{
        position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 30,
        bgcolor: "rgba(20,19,51,0.96)",
        backdropFilter: "blur(16px)",
        borderTop: `1px solid ${COLORS.border}`,
        // Keeps the row clear of the iOS home indicator.
        pb: "env(safe-area-inset-bottom)"
      }}
    >
      <BottomNavigation
        value={value}
        onChange={(_e, next) => jump(next)}
        showLabels
        sx={{
          bgcolor: "transparent",
          height: NAV_HEIGHT,
          "& .MuiBottomNavigationAction-root": {
            color: COLORS.muted,
            minWidth: 0,
            "&.Mui-selected": { color: COLORS.cyan }
          },
          "& .MuiBottomNavigationAction-label": { fontSize: 10.5, fontWeight: 700 }
        }}
      >
        {ITEMS.map(({ id, label, Icon }) => (
          <BottomNavigationAction key={id} label={label} icon={<Icon sx={{ fontSize: 20 }} />} />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
